module.exports = __webpack_public_path__ + "static/img/btn-connect-wallet-cn.ef03294b.png";